import styled, { css } from 'styled-components'

export const StyledTable = styled.table`
  td[colspan="42"] {
	padding: 0;
  }
`

export const Td = styled.td<{ status: boolean }>`
  max-width: 20rem;
  margin-left: auto;
  margin-right: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${({ status }) =>
    status &&
    css`
      // display: flex !important;
      // align-items: center;
      // justify-content: center;
    `}
`
